import { Badge, GoalBankCard, GoalBankCardProps } from "@fronterahealth/frontera-ui-components";

const GoalBankCardWithNodeTitle = GoalBankCard as React.FC<
  Omit<GoalBankCardProps, "title"> & { title: React.ReactNode }
>;

interface AddShortTermGoalsBankCardProps {
  id: string;
  goalName: string;
  description?: string | undefined | null;
  selected: boolean;
  subtitle?: string | undefined | null;
  onClick: () => void;
  suggestionType?: "ai";
}

export const AddShortTermGoalsBankCard: React.FC<AddShortTermGoalsBankCardProps> = ({
  id,
  goalName,
  description,
  selected,
  subtitle,
  onClick,
  suggestionType,
}) => {
  const titleContent =
    suggestionType === "ai" ? (
      <span className="flex items-center gap-1.5">
        {goalName}
        <Badge text="AI" appearance="ai" className="animate-none!" />
      </span>
    ) : (
      goalName
    );

  return (
    <GoalBankCardWithNodeTitle
      key={id}
      id={id}
      title={titleContent}
      subtitle={subtitle ?? ""}
      body={description ?? ""}
      selected={selected}
      onClick={onClick}
    />
  );
};
